import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NewEnrollmentService } from 'src/app/pages/secure/new-enrollment/new-enrollment.service';
import { AppConstants } from '../../constants/app-constants';
import { UserCacheService } from '../../services/user-cache.service';
import { WaiverService } from './../../services/waiver/waiver.service';
import moment from 'moment';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ReviewComponent implements OnInit {
    @Input() content: any;
    @Input() selectCoverage: any;
    @Input() aboutYou: any;
    @Input() dependents: any;
    @Input() reviewContent: any;
    //@Input() enrollmentData: any;
    @Input() path: any;
    @Input() selectWavier: any;
    @Input() currentInsurance: any;
    @Input() contentInsurance: any;
    @Input() enrollmentIdDep: number;
    @Output() editDates: EventEmitter<any> = new EventEmitter<any>();
    @Output() editWaiverDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() editDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() showSpinner: EventEmitter<any> = new EventEmitter<any>();
    waiverReview: any = {};
    formSubmitted = false;
    waiverAgreement: any;
    enrollmentData: any;
    displaySpinner = false;

    constructor(public userCacheService: UserCacheService, public waiverSvc: WaiverService, private enrollmentService: NewEnrollmentService) {
    }

    ngOnInit(): void {
        this.getReviewData();
    }

    getReviewData(): void {
        let enrollmentData = this.userCacheService.getUserData(AppConstants.NewEnrollmentModel);
        let request = {
            enrollmentId: enrollmentData?.enrollmentId,
            participationId: enrollmentData?.participationId,
            termId: enrollmentData?.termId,
        };
        if(!enrollmentData && this.aboutYou) {
            request.enrollmentId = request.enrollmentId?request.enrollmentId:this.aboutYou.enrollment_id;
            request.participationId = this.aboutYou.participation_id;
            request.termId = this.aboutYou.term_id;
        }
        if(this.enrollmentIdDep) {
            request.enrollmentId = this.enrollmentIdDep;
        }
        if (this.path === 'New-Enrollment' || this.path === 'new-enrollment') {
            this.path = 'new-enrollment';
            this.displaySpinner = true;
            this.enrollmentService.enrollmentReview(request).subscribe((data: any) => {
                this.displaySpinner = false;
                if (data.status === 'SUCCESS') {
                    this.showSpinner.emit({ val: false, message: 'SUCCESS' });
                    this.enrollmentData = data;
                    this.dependents = { dependent: data.dependentDetails };
                } else {
                    this.showSpinner.emit({ val: false, message: 'FAILURE' });
                }
            });
        } else if (this.path === 'waiver') {
            if (enrollmentData) {
                const request = {
                    enrollmentId: enrollmentData.enrollmentId,
                    termId: enrollmentData.termId,
                    participationId: enrollmentData.participationId
                };
                this.displaySpinner = true;
                this.waiverSvc.waiverReview(request).subscribe((data: any) => {
                    this.displaySpinner = false;
                    if (data && data.status === AppConstants.SUCCESS_STATUS) {
                        this.waiverReview = data.data;
                        if (this.waiverReview && this.waiverReview.enrollment_status.toLowerCase() === 'roster') {
                            this.waiverReview.enrollment_status = 'ENROLLED AUTO';
                        }
                    }
                });
            }
        }

    }

    updateDates(): void {
        this.editDates.emit(this.reviewContent);
    }
    formatDate(e: any): string {
        if (e && moment(e.toString(), 'MM/DD/YYYY', true).isValid()) {
            return e;
        }
        else if (e) {
            const date = e.toString().split(' ');
            return date.length >= 4 ? moment([date[0], date[1], date[2], date[3]].join(' ')).format('MM/DD/YYYY') : moment(e).format('MM/DD/YYYY');
        }
        else {
            return e;
        }
    }
    edit(value): void {
        this.editDetails.emit(value);
    }
    editWaiver(value): void {
        this.editWaiverDetails.emit(value);
    }

    onSubmitForm(): void {
        this.formSubmitted = true;
    }
}
